[
  {
    "registrationNumber": "99999",
    "name": "Geen medicijnen gebruikt",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 89
  },
  {
    "registrationNumber": "99999",
    "name": "Kein Medizin gebraucht",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 90
  },
  {
    "registrationNumber": "99999",
    "name": "Geen medicijnen gebruikt",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 182
  },
  {
    "registrationNumber": "REG NL 10055",
    "name": "Apralan oplosbaar 100% ",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 2
  },
  {
    "registrationNumber": "REG NL 101024",
    "name": "Pharmasin 100 mg/g",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 177
  },
  {
    "registrationNumber": "REG NL 10112",
    "name": "Octacilline",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 17
  },
  {
    "registrationNumber": "REG NL 10213",
    "name": "Tylogran WSP",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 28
  },
  {
    "registrationNumber": "REG NL 102303",
    "name": "Coliplus",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 197
  },
  {
    "registrationNumber": "REG NL 10275",
    "name": "Soludox 50%",
    "country": "NL",
    "waitingTime": 3,
    "plukonId": 23
  },
  {
    "registrationNumber": "REG NL 10333",
    "name": "Phenoxypen WSP",
    "country": "NL",
    "waitingTime": 2,
    "plukonId": 22
  },
  {
    "registrationNumber": "REG NL 10409",
    "name": "Enrox orale opl 100 mg/ml",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 9
  },
  {
    "registrationNumber": "REG NL 104343",
    "name": "Neosol 100%",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 16
  },
  {
    "registrationNumber": "REG NL 104773",
    "name": "Aivlosin 625 mg/gr Granulaat",
    "country": "NL",
    "waitingTime": 2,
    "plukonId": 97
  },
  {
    "registrationNumber": "REG NL 10502",
    "name": "Kariflox 10%",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 67
  },
  {
    "registrationNumber": "REG NL 10503",
    "name": "Lanflox 10%",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 60
  },
  {
    "registrationNumber": "REG NL 10544",
    "name": "Floxamax 10%",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 63
  },
  {
    "registrationNumber": "REG NL 105505",
    "name": "Soludox (10 mg/kg levend)",
    "country": "NL",
    "waitingTime": 3,
    "plukonId": 118
  },
  {
    "registrationNumber": "REG NL 10560",
    "name": "Tilmovet 25% Oral Solution",
    "country": "NL",
    "waitingTime": 12,
    "plukonId": 94
  },
  {
    "registrationNumber": "REG NL 112820",
    "name": "Suramox 1000 mg/g",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 114
  },
  {
    "registrationNumber": "REG NL 113695",
    "name": "Amoxy Active",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 120
  },
  {
    "registrationNumber": "REG NL 113929",
    "name": "Citramox 500 mg/g",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 190
  },
  {
    "registrationNumber": "REG NL 115238",
    "name": "Solamocta",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 171
  },
  {
    "registrationNumber": "REG NL 117064",
    "name": "Metaxol 20/100 mg/ml",
    "country": "NL",
    "waitingTime": 5,
    "plukonId": 176
  },
  {
    "registrationNumber": "REG NL 117571",
    "name": "Citramox 1000mg/g",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 178
  },
  {
    "registrationNumber": "REG NL 117624",
    "name": "Coldostin",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 281
  },
  {
    "registrationNumber": "REG NL 119058",
    "name": "Phenocillin 800 mg/g poeder",
    "country": "NL",
    "waitingTime": 2,
    "plukonId": 282
  },
  {
    "registrationNumber": "REG NL 123523",
    "name": "Coccibal 200mg/ml",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 222
  },
  {
    "registrationNumber": "REG NL 124847",
    "name": "Amproline 400 mg/ml",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 283
  },
  {
    "registrationNumber": "REG NL 125094",
    "name": "Dophexine 20 mg/g",
    "country": "NL",
    "waitingTime": 0,
    "plukonId": 287
  },
  {
    "registrationNumber": "REG NL 1311",
    "name": "Sulfadimidin-Na",
    "country": "NL",
    "waitingTime": 15,
    "plukonId": 24
  },
  {
    "registrationNumber": "REG NL 1503",
    "name": "Sulfaquinoxaline Natrium",
    "country": "NL",
    "waitingTime": 14,
    "plukonId": 115
  },
  {
    "registrationNumber": "REG NL 2182",
    "name": "Colisol",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 198
  },
  {
    "registrationNumber": "REG NL 2929",
    "name": "Baytril 10% oral oplosbaar",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 3
  },
  {
    "registrationNumber": "REG NL 3095",
    "name": "Lincomycine 20%",
    "country": "NL",
    "waitingTime": 10,
    "plukonId": 113
  },
  {
    "registrationNumber": "REG NL 3404",
    "name": "Colistin",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 216
  },
  {
    "registrationNumber": "REG NL 4256",
    "name": "Paracilline oplosbare poeder",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 21
  },
  {
    "registrationNumber": "REG NL 5193",
    "name": "Ampisol 100%",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 1
  },
  {
    "registrationNumber": "REG NL 5388",
    "name": "Cosumix Plus",
    "country": "NL",
    "waitingTime": 3,
    "plukonId": 4
  },
  {
    "registrationNumber": "REG NL 7146",
    "name": "Doxycycline 20% WO",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 7
  },
  {
    "registrationNumber": "REG NL 7276",
    "name": "Neomycinesulfaat",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 15
  },
  {
    "registrationNumber": "REG NL 7611",
    "name": "T.S.-Sol 20/100",
    "country": "NL",
    "waitingTime": 5,
    "plukonId": 26
  },
  {
    "registrationNumber": "REG NL 8076",
    "name": "T.S.-Sol",
    "country": "NL",
    "waitingTime": 7,
    "plukonId": 25
  },
  {
    "registrationNumber": "REG NL 8413",
    "name": "Oxytetracycline 40% WO",
    "country": "NL",
    "waitingTime": 8,
    "plukonId": 19
  },
  {
    "registrationNumber": "REG NL 8753",
    "name": "Doxylin 50% WSP",
    "country": "NL",
    "waitingTime": 5,
    "plukonId": 91
  },
  {
    "registrationNumber": "REG NL 8758",
    "name": "Enterflume",
    "country": "NL",
    "waitingTime": 2,
    "plukonId": 10
  },
  {
    "registrationNumber": "REG NL 9106",
    "name": "Methoxasol-T",
    "country": "NL",
    "waitingTime": 6,
    "plukonId": 14
  },
  {
    "registrationNumber": "REG NL 9612",
    "name": "Soludox 500 mg (10 mg/kg levend)",
    "country": "NL",
    "waitingTime": 3,
    "plukonId": 75
  },
  {
    "registrationNumber": "REG NL 9617",
    "name": "Oxytetracycline-HCL",
    "country": "NL",
    "waitingTime": 8,
    "plukonId": 20
  },
  {
    "registrationNumber": "REG NL 9972",
    "name": "Pulmotil AC",
    "country": "NL",
    "waitingTime": 12,
    "plukonId": 96
  },
  {
    "registrationNumber": "REG NL 9984",
    "name": "Tylan WO",
    "country": "NL",
    "waitingTime": 1,
    "plukonId": 27
  },
  {
    "registrationNumber": "13076.00.01",
    "name": "Pyanosid Pulver",
    "country": "DE",
    "waitingTime": 8,
    "plukonId": 49
  },
  {
    "registrationNumber": "13113.02.02",
    "name": "Baytril 10%",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 36
  },
  {
    "registrationNumber": "16993.00.00",
    "name": "Colistinsulfat 1Mio I.E./g",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 207
  },
  {
    "registrationNumber": "25661.00.00",
    "name": "Duphamycin Meta",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 189
  },
  {
    "registrationNumber": "3100095.00.00",
    "name": "Aviapen",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 34
  },
  {
    "registrationNumber": "3100311.00.00",
    "name": "Ursocyclin Pulver 20%",
    "country": "DE",
    "waitingTime": 14,
    "plukonId": 58
  },
  {
    "registrationNumber": "400220.00.00",
    "name": "Pulmotil AC",
    "country": "DE",
    "waitingTime": 12,
    "plukonId": 112
  },
  {
    "registrationNumber": "400790.00.00",
    "name": "Lincospectin Pulver",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 44
  },
  {
    "registrationNumber": "400920.00.00",
    "name": "Tylan Soluble 1000g",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 55
  },
  {
    "registrationNumber": "400970.00.00",
    "name": "Phenoxypen WSP",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 48
  },
  {
    "registrationNumber": "401093.02.00",
    "name": "Unisol 10%",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 59
  },
  {
    "registrationNumber": "401095.02.00",
    "name": "Enro K",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 62
  },
  {
    "registrationNumber": "401098.01.01",
    "name": "Enro-Sleecol",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 85
  },
  {
    "registrationNumber": "401190.00.00",
    "name": "Methoxasol T 20/100 mg/ml",
    "country": "DE",
    "waitingTime": 6,
    "plukonId": 46
  },
  {
    "registrationNumber": "401315.00.00",
    "name": "Soludox 500 mg/g Pulver (dosis10mg/kg)",
    "country": "DE",
    "waitingTime": 3,
    "plukonId": 77
  },
  {
    "registrationNumber": "401320.00.00",
    "name": "Pulmodox 500 mg/g",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 70
  },
  {
    "registrationNumber": "401347.00.00",
    "name": "Lanflox 100 mg/ml",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 73
  },
  {
    "registrationNumber": "401355.00.00",
    "name": "Octacilline",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 65
  },
  {
    "registrationNumber": "401356.00.00",
    "name": "Spectron",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 83
  },
  {
    "registrationNumber": "401499.00.00",
    "name": "Doxycycline Caliers 500mg/g",
    "country": "DE",
    "waitingTime": 6,
    "plukonId": 107
  },
  {
    "registrationNumber": "401515.00.00",
    "name": "Bay Cubis 325 mg/g",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 99
  },
  {
    "registrationNumber": "401519.00.00",
    "name": "Eimeryl 200 mg/ml",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 98
  },
  {
    "registrationNumber": "401522.00.00",
    "name": "Pharmasin 100% w/w",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 87
  },
  {
    "registrationNumber": "401567.00.00",
    "name": "Beladox 500 mg/g",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 105
  },
  {
    "registrationNumber": "401583.00.00",
    "name": "Colistinsulfat 100 1000 mg/g",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 208
  },
  {
    "registrationNumber": "401661.00.00",
    "name": "Enrotron 100 mg/ml",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 187
  },
  {
    "registrationNumber": "401674.00.00",
    "name": "Tylo-Suscit 100% Kompaktat",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 188
  },
  {
    "registrationNumber": "401875.00.00",
    "name": "Tylo-Suscit 100% Kompaktat",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 121
  },
  {
    "registrationNumber": "401891.00.00",
    "name": "Suramox 1000 mg/g Pulver",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 109
  },
  {
    "registrationNumber": "401913.00.00",
    "name": "Enroxal 100 mg/ml",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 125
  },
  {
    "registrationNumber": "401991.00.00",
    "name": "Amoxy Active",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 124
  },
  {
    "registrationNumber": "402084.00.00",
    "name": "Doxx-Sol 500 mg/g",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 221
  },
  {
    "registrationNumber": "402114.00.00",
    "name": "Solamocta 697 mg/g",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 145
  },
  {
    "registrationNumber": "402153.00.00",
    "name": "Exflow Vet 10 mg/g Pulver",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 166
  },
  {
    "registrationNumber": "402158.00.00",
    "name": "Tylogran 1000mg/g",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 167
  },
  {
    "registrationNumber": "402170.00.00",
    "name": "Phenocillin 800 mg/g",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 148
  },
  {
    "registrationNumber": "402182.00.00",
    "name": "Rhemox Forte 1000 mg/g",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 212
  },
  {
    "registrationNumber": "402184.00.00",
    "name": "Amatib 800 mg/g Pulver",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 169
  },
  {
    "registrationNumber": "402187.00.00",
    "name": "Belacol 100% Kompaktat",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 199
  },
  {
    "registrationNumber": "402204.00.00",
    "name": "Mycoflor 200 mg/ml",
    "country": "DE",
    "waitingTime": 28,
    "plukonId": 219
  },
  {
    "registrationNumber": "402209.00.00",
    "name": "Vetmulin 450 mg/g",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 285
  },
  {
    "registrationNumber": "402210.00.00",
    "name": "Biocillin",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 284
  },
  {
    "registrationNumber": "402212.00.00",
    "name": "Metaxol 20/100 mg/ml",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 174
  },
  {
    "registrationNumber": "402241.00.00",
    "name": "Doxipulvis 500 mg/g",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 193
  },
  {
    "registrationNumber": "402260.00.00",
    "name": "Coldostin",
    "country": "DE",
    "waitingTime": 1,
    "plukonId": 204
  },
  {
    "registrationNumber": "402261.00.00",
    "name": "Belacol 24% Liquid",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 220
  },
  {
    "registrationNumber": "402279.00.00",
    "name": "Doxatib 500 mg/g",
    "country": "DE",
    "waitingTime": 9,
    "plukonId": 185
  },
  {
    "registrationNumber": "402283.00.00",
    "name": "Altidox 500 mg/g Pulver",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 173
  },
  {
    "registrationNumber": "402305.00.00",
    "name": "Apravet",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 218
  },
  {
    "registrationNumber": "402368.00.00",
    "name": "T.S.Sol 20/100 mg/ml",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 186
  },
  {
    "registrationNumber": "402556.00.00",
    "name": "Lincobel 400 mg/g",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 196
  },
  {
    "registrationNumber": "402762.00.00",
    "name": "Bromhex-Air forte 25mg/g",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 286
  },
  {
    "registrationNumber": "6093467.00.00",
    "name": "Sulfadimidin-Na",
    "country": "DE",
    "waitingTime": 14,
    "plukonId": 51
  },
  {
    "registrationNumber": "6242884.00.00",
    "name": "Sulfadimidin-Na",
    "country": "DE",
    "waitingTime": 14,
    "plukonId": 52
  },
  {
    "registrationNumber": "6500561.00.00",
    "name": "Ampiciph",
    "country": "DE",
    "waitingTime": 6,
    "plukonId": 33
  },
  {
    "registrationNumber": "6500868.00.00",
    "name": "Colistin C12 GS 120 mg/g",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 206
  },
  {
    "registrationNumber": "6501135.00.00",
    "name": "Klato Lan Feed",
    "country": "DE",
    "waitingTime": 5,
    "plukonId": 110
  },
  {
    "registrationNumber": "6502206.00.00",
    "name": "Colistinsulfat 100% aniMedica",
    "country": "DE",
    "waitingTime": 2,
    "plukonId": 209
  },
  {
    "registrationNumber": "6872786.00.00",
    "name": "Sulfadimidin-Na 100%",
    "country": "DE",
    "waitingTime": 14,
    "plukonId": 92
  },
  {
    "registrationNumber": "9187.00.01",
    "name": "Neomycinsulfat",
    "country": "DE",
    "waitingTime": 7,
    "plukonId": 47
  },
  {
    "registrationNumber": "974.00.00",
    "name": "Apralan Soluble",
    "country": "DE",
    "waitingTime": 0,
    "plukonId": 217
  },
  {
    "registrationNumber": "BE-V061957",
    "name": "Linco-Spectin 100",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 129
  },
  {
    "registrationNumber": "BE-V108701",
    "name": "Flubenol 5% (Pot)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 266
  },
  {
    "registrationNumber": "BE-V109720",
    "name": "Methoxasol 20/100 mg/ml",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 152
  },
  {
    "registrationNumber": "BE-V111657",
    "name": "Tiamutin 45%",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 277
  },
  {
    "registrationNumber": "BE-V115814",
    "name": "Tylan Solube 100% (1000 G)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 153
  },
  {
    "registrationNumber": "BE-V121317",
    "name": "Flumiquil 50%",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 172
  },
  {
    "registrationNumber": "BE-V127154",
    "name": "Cosumix Plus",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 139
  },
  {
    "registrationNumber": "BE-V140314",
    "name": "Baytril 10% oral oplosbaar",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 137
  },
  {
    "registrationNumber": "BE-V142721",
    "name": "Spectoliphen 100",
    "country": "BE",
    "waitingTime": 3,
    "plukonId": 128
  },
  {
    "registrationNumber": "BE-V151331",
    "name": "Lincocin 40%",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 144
  },
  {
    "registrationNumber": "BE-V169136",
    "name": "Origin",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 154
  },
  {
    "registrationNumber": "BE-V171491",
    "name": "Promycine 1.000 I.U./mg",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 272
  },
  {
    "registrationNumber": "BE-V191527",
    "name": "Soludox 15%  (sachet)",
    "country": "BE",
    "waitingTime": 9,
    "plukonId": 233
  },
  {
    "registrationNumber": "BE-V192211",
    "name": "Oxytetracycline",
    "country": "BE",
    "waitingTime": 28,
    "plukonId": 230
  },
  {
    "registrationNumber": "BE-V192272",
    "name": "Promycine 4.800 I.U./mg (Zak)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 273
  },
  {
    "registrationNumber": "BE-V199157",
    "name": "Dokamax 80%",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 215
  },
  {
    "registrationNumber": "BE-V206613",
    "name": "Pulmotil AC",
    "country": "BE",
    "waitingTime": 12,
    "plukonId": 232
  },
  {
    "registrationNumber": "BE-V207742",
    "name": "Enterflum",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 180
  },
  {
    "registrationNumber": "BE-V216422",
    "name": "Tylosine 75%",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 245
  },
  {
    "registrationNumber": "BE-V233764",
    "name": "Amoxycilline 70%",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 143
  },
  {
    "registrationNumber": "BE-V235523",
    "name": "Emdotrim 10%",
    "country": "BE",
    "waitingTime": 4,
    "plukonId": 131
  },
  {
    "registrationNumber": "BE-V240615",
    "name": "Soludox 500 mg/ml (10 mg/kg)",
    "country": "BE",
    "waitingTime": 3,
    "plukonId": 155
  },
  {
    "registrationNumber": "BE-V240615",
    "name": "Soludox 500 mg/ml (20mg/kg)",
    "country": "BE",
    "waitingTime": 9,
    "plukonId": 132
  },
  {
    "registrationNumber": "BE-V263916",
    "name": "Doxylin 50%",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 141
  },
  {
    "registrationNumber": "BE-V279194",
    "name": "Octacilline",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 151
  },
  {
    "registrationNumber": "BE-V284986",
    "name": "Solubenol",
    "country": "BE",
    "waitingTime": 4,
    "plukonId": 275
  },
  {
    "registrationNumber": "BE-V292354",
    "name": "Phenoxypen WSP",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 133
  },
  {
    "registrationNumber": "BE-V300955",
    "name": "Tylan oplosbaar  (100 G)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 242
  },
  {
    "registrationNumber": "BE-V300964",
    "name": "Tiamutin 10% premix",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 276
  },
  {
    "registrationNumber": "BE-V308874",
    "name": "Tylan 100 vet premix",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 241
  },
  {
    "registrationNumber": "BE-V313871",
    "name": "Soludox 50% - 10 mg/kg  (ionomeer sachet)",
    "country": "BE",
    "waitingTime": 3,
    "plukonId": 236
  },
  {
    "registrationNumber": "BE-V313871",
    "name": "Soludox 50% - 20 mg/kg  (ionomeer sachet)",
    "country": "BE",
    "waitingTime": 9,
    "plukonId": 251
  },
  {
    "registrationNumber": "BE-V322077",
    "name": "Promycine 4.800 I.U./mg (Pot)",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 274
  },
  {
    "registrationNumber": "BE-V324222",
    "name": "Tilmovet 25% Oral Solution",
    "country": "BE",
    "waitingTime": 12,
    "plukonId": 130
  },
  {
    "registrationNumber": "BE-V326837",
    "name": "Flubenol 5% (Zak)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 265
  },
  {
    "registrationNumber": "BE-V327327",
    "name": "Soludox 15%  (container)",
    "country": "BE",
    "waitingTime": 9,
    "plukonId": 234
  },
  {
    "registrationNumber": "BE-V327336",
    "name": "Soludox 15%  (doos)",
    "country": "BE",
    "waitingTime": 9,
    "plukonId": 235
  },
  {
    "registrationNumber": "BE-V333471",
    "name": "Vetmulin 45% drinkwater",
    "country": "BE",
    "waitingTime": 3,
    "plukonId": 280
  },
  {
    "registrationNumber": "BE-V333837",
    "name": "Byemite",
    "country": "BE",
    "waitingTime": 25,
    "plukonId": 253
  },
  {
    "registrationNumber": "BE-V334056",
    "name": "Vetmulin 10% premix",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 279
  },
  {
    "registrationNumber": "BE-V337172",
    "name": "Pharmasin 250 mg/g premix (Papieren zak)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 249
  },
  {
    "registrationNumber": "BE-V337181",
    "name": "Pharmasin 250 mg/g premix (PE/Alu/PET zak)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 250
  },
  {
    "registrationNumber": "BE-V338143",
    "name": "Hydrodoxx 50% (Zak)",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 267
  },
  {
    "registrationNumber": "BE-V338292",
    "name": "Unisol",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 240
  },
  {
    "registrationNumber": "BE-V343113",
    "name": "Enro-K",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 146
  },
  {
    "registrationNumber": "BE-V355144",
    "name": "Floxamax 10%",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 150
  },
  {
    "registrationNumber": "BE-V360184",
    "name": "Coliplus",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 210
  },
  {
    "registrationNumber": "BE-V362266",
    "name": "Phenoxypen (Combi-tin)",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 246
  },
  {
    "registrationNumber": "BE-V371935",
    "name": "Doxyveto-Citrix (Zak)",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 258
  },
  {
    "registrationNumber": "BE-V379145",
    "name": "Spectron 100",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 237
  },
  {
    "registrationNumber": "BE-V379373",
    "name": "Hydrodoxx 50%  (Pot)",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 268
  },
  {
    "registrationNumber": "BE-V383914",
    "name": "Aurofac Granular 250mg/g",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 252
  },
  {
    "registrationNumber": "BE-V387143",
    "name": "Pharmasin 100% w/w (Zak)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 142
  },
  {
    "registrationNumber": "BE-V387152",
    "name": "Pharmasin 100% wateroplosbaar (Pot)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 248
  },
  {
    "registrationNumber": "BE-V388726",
    "name": "Enroshort  (HDPE fles)",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 228
  },
  {
    "registrationNumber": "BE-V388735",
    "name": "Enroshort 100 mg/ml",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 134
  },
  {
    "registrationNumber": "BE-V388735",
    "name": "Enroshort   (Glazen injectieflacon)",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 229
  },
  {
    "registrationNumber": "BE-V400434",
    "name": "Quinoflox 100 mg/ml",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 195
  },
  {
    "registrationNumber": "BE-V418521",
    "name": "Coccibal",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 254
  },
  {
    "registrationNumber": "BE-V420192",
    "name": "Eimeryl",
    "country": "BE",
    "waitingTime": 0,
    "plukonId": 223
  },
  {
    "registrationNumber": "BE-V422143",
    "name": "Dozuril",
    "country": "BE",
    "waitingTime": 16,
    "plukonId": 260
  },
  {
    "registrationNumber": "BE-V430927",
    "name": "Methoxasol-T",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 149
  },
  {
    "registrationNumber": "BE-V435723",
    "name": "Doxylin 50%",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 227
  },
  {
    "registrationNumber": "BE-V442267",
    "name": "Flimabo (Sachet)",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 263
  },
  {
    "registrationNumber": "BE-V442547",
    "name": "Flimabend (Sachet)",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 261
  },
  {
    "registrationNumber": "BE-V442845",
    "name": "Suramox 100 mg/g",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 156
  },
  {
    "registrationNumber": "BE-V442845",
    "name": "Suramox",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 238
  },
  {
    "registrationNumber": "BE-V445173",
    "name": "Enroxal 100 mg/ml  (Glas flacon)",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 147
  },
  {
    "registrationNumber": "BE-V445182",
    "name": "Enroxal (HDPE fles)",
    "country": "BE",
    "waitingTime": 7,
    "plukonId": 247
  },
  {
    "registrationNumber": "BE-V461093",
    "name": "Amoxy Active   (Emmer)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 225
  },
  {
    "registrationNumber": "BE-V461102",
    "name": "Amoxy Active  (Securitainer)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 136
  },
  {
    "registrationNumber": "BE-V468826",
    "name": "Doxx-Sol",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 257
  },
  {
    "registrationNumber": "BE-V473173",
    "name": "Tylogran (Combi-tin)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 243
  },
  {
    "registrationNumber": "BE-V485431",
    "name": "Phenocillin 800 mg/g",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 191
  },
  {
    "registrationNumber": "BE-V485431",
    "name": "Phenocillin 800 mg/g \u2013 500 gr",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 231
  },
  {
    "registrationNumber": "BE-V489502",
    "name": "Solamocta",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 181
  },
  {
    "registrationNumber": "BE-V498657",
    "name": "Colixyme 22,5 mui/g",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 211
  },
  {
    "registrationNumber": "BE-V499413",
    "name": "Flimabend (Pot)",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 262
  },
  {
    "registrationNumber": "BE-V502017",
    "name": "Flimabo (Pot)",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 264
  },
  {
    "registrationNumber": "BE-V504346",
    "name": "Coldostin 4.800.000 UI/g",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 226
  },
  {
    "registrationNumber": "BE-V509600",
    "name": "Doxyveto-Citrix (Pot)",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 259
  },
  {
    "registrationNumber": "BE-V519653",
    "name": "Tylogran (Emmer)",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 244
  },
  {
    "registrationNumber": "BE-V519662",
    "name": "Tylogran 1000 mg/g",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 214
  },
  {
    "registrationNumber": "BE-V520764",
    "name": "T.S. Sol 20 mg/ml - 100 mg/ml (Fles)",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 239
  },
  {
    "registrationNumber": "BE-V520773",
    "name": "T.S. Sol 20 mg/ml - 100 mg/ml (Jerrycan)",
    "country": "BE",
    "waitingTime": 5,
    "plukonId": 194
  },
  {
    "registrationNumber": "BE-V97/003",
    "name": "Dicural 50 mg/ml",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 140
  },
  {
    "registrationNumber": "BE-VEU/2/04/044/019",
    "name": "Aivlosin",
    "country": "BE",
    "waitingTime": 2,
    "plukonId": 224
  },
  {
    "registrationNumber": "BE-VEU/2/11/135/002",
    "name": "Panacur Aquasol",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 270
  },
  {
    "registrationNumber": "BE-VEU/2/11/135/003",
    "name": "Panacur Aquasol",
    "country": "BE",
    "waitingTime": 6,
    "plukonId": 271
  },
  {
    "registrationNumber": "BE-V475306",
    "name": "Doxivet (dosis 10mg/kg)",
    "country": "BE",
    "waitingTime": 3,
    "plukonId": 255
  },
  {
    "registrationNumber": "BE-V475306",
    "name": "Doxivet (dosis 20mg/kg)",
    "country": "BE",
    "waitingTime": 12,
    "plukonId": 256
  },
  {
    "registrationNumber": "",
    "name": "Oxytem 80%",
    "country": "BE",
    "waitingTime": 28,
    "plukonId": 269
  },
  {
    "registrationNumber": "",
    "name": "Tylan 250 vet premix",
    "country": "BE",
    "waitingTime": 1,
    "plukonId": 278
  }
]
